import { render, staticRenderFns } from "./PericiasSelect.vue?vue&type=template&id=746cf9dc"
import script from "./PericiasSelect.vue?vue&type=script&lang=js"
export * from "./PericiasSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports